import React, { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  as?: React.ElementType<any>
}

export const Heading = ({
  children,
  as: Component = 'h2',
  className,
}: HeadingProps) => {
  const _className = twMerge(
    `font-medium text-5xl leading-tight lg:text-5xl text-secondary`,
    className,
  )
  return <Component className={_className}>{children}</Component>
}
